// R6 — the landing page's first API calls start before its code has downloaded.
// index.html starts the profile + home calls (window.__asPrefetch); this module adds the
// listing and home-shelf calls, which need the app's config. services/api.js answers a
// matching GET from a started call once, within PRE_TTL. Same URLs as the pages build.
import {
  parseCitySegment, pluralSegment, CATEGORY_SLUGS, SINGULAR_TYPE, BUDGET_BANDS, TYPE_LABEL,
} from '../config/geo';
import { readPref, isBot } from './pref';

const PRE_TTL = 20000;

export function takePreload(url) {
  if (typeof window === 'undefined' || !window.__asPre || !window.__asPreKey) return null;
  const k = window.__asPreKey(url);
  const e = window.__asPre[k];
  if (!e) return null;
  delete window.__asPre[k];
  return Date.now() - e.t < PRE_TTL ? e.p : null;
}

const pre = (path, params) => window.__asPrefetch(path, params);

function readLocArea() {
  try {
    const m = document.cookie.match(/(?:^|; )as_loc=([^;]+)/);
    const saved = m ? JSON.parse(decodeURIComponent(m[1])) : null;
    return saved && saved.city ? saved.area || null : null;
  } catch (e) {
    return null;
  }
}

// HomePage: rotating shelf for the host's area (and preferred type).
function home() {
  const pref = isBot() ? null : readPref();
  const area = readLocArea() || pref?.area || null;
  const base = { size: 12, ...(area ? { area } : {}) };
  pre('/artists/shelf', pref?.category ? { ...base, type: pref.category } : base);
}

function listingContext(segs) {
  if (segs[0] !== 'delhi-ncr') return null;
  if (segs.length === 2 && segs[1] === 'artists') return {};
  if (segs.length === 2) return pluralSegment(segs[1]) ? null : parseCitySegment(segs[1]);
  if (segs.length === 3 && segs[1] !== 'c' && segs[1] !== 'price-guide' && !SINGULAR_TYPE[segs[2]]) {
    return { occasionSlug: segs[1], category: CATEGORY_SLUGS[segs[2]], categorySlug: segs[2] };
  }
  return null;
}

// ArtistListingPage: page resolve, grid, type counts, new-artist row, popular searches.
function listing(segs, sp) {
  const ctx = listingContext(segs);
  if (!ctx) return;
  const occasionSlug = ctx.occasionSlug || '';
  const category = ctx.category || '';
  const pathArea = ctx.area || '';
  const q = (sp.get('q') || '').trim();
  const sort = sp.get('sort') || 'recommended';
  const page = Math.max(1, parseInt(sp.get('page') || '1', 10));
  if (!Number.isFinite(page)) return;
  const area = pathArea || sp.get('area') || '';
  const typeKey = category ? '' : (sp.get('type') || '').split(',').filter((t) => TYPE_LABEL[t]).join(',');

  const lp = {};
  if (occasionSlug) lp.occasion = occasionSlug;
  if (ctx.categorySlug) lp.category = category;
  if (pathArea) lp.area = pathArea;
  pre('/listing/page', lp);
  if (occasionSlug) pre(`/pins/occasion/${occasionSlug}/hero-artist`);

  const base = { city_group: 'delhi-ncr' };
  if (occasionSlug) base.occasion = occasionSlug;
  if (category) base.category = category;
  if (q) base.q = q;
  if (typeKey) base.type = typeKey;
  const perPage = window.matchMedia('(min-width:900px)').matches ? 12 : 6;
  const p = { ...base, sort, limit: perPage * page };
  const band = BUDGET_BANDS.find((b) => b.value === (sp.get('budget') || ''));
  if (band) { if (band.min != null) p.price_min = band.min; if (band.max != null) p.price_max = band.max; }
  const rating = sp.get('rating') || '';
  if (rating) p.min_rating = parseFloat(rating);
  if (sp.get('verified') === '1') p.verified = 1;
  if (area) p.area = area;
  pre('/artists', { ...p, include_travel: 1, ...(area ? { fill_area: 1 } : {}) });
  if (!category) {
    const f = { ...p };
    delete f.type; delete f.sort; delete f.limit;
    pre('/artists/facets', f);
  }
  if (sort === 'recommended') pre('/artists', { ...base, new_only: 1, sort: 'recommended', limit: 6, ...(area ? { area } : {}) });
  if (!occasionSlug && !category && !pathArea && !q) pre('/search-events/popular', area ? { area } : {});
}

(function start() {
  if (typeof window === 'undefined' || !window.__asPrefetch) return;
  try {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path === '/' || path === '/delhi-ncr') home();
    else listing(path.split('/').filter(Boolean).map(decodeURIComponent), new URLSearchParams(window.location.search));
  } catch (e) { /* best effort: the page makes its own calls anyway */ }
}());
